import { C_PROPERTIES_STATUS } from "@/src-refactor/modules/shared/model/const/property/real-estate-status";
import { C_REALESTATE_TYPES, C_REALESTATE_TYPES_PROJECT } from "@/src-refactor/modules/shared/model/const/property/real-estate-type.const";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import { useGetDetailPropertyQuery } from "@/src-refactor/modules/store/qrtk/services/realestate/realestate.qrtk";
import HCheckArray from "@rf-helper/check-have-value";
import { useEffect, useMemo } from "react";
import { useWatch } from "react-hook-form";
import { useParams } from "react-router-dom";

import { C_BUSINESS_TYPE } from "@/src-refactor/modules/shared/model/const/property/business-type.const";
import { CPropertyFormKeys } from "../../util/schemas/property-schema/propertySchema";
const usePropertyFormHelp = () => {
  const [business_types_property, type_property] = useWatch({
    name: [
      CPropertyFormKeys.business_types_property,
      CPropertyFormKeys.type_property
    ]
  });
  const params = useParams<{ id: string }>();

  const GET_PROPERTY_DETAIL = useGetDetailPropertyQuery(
    {
      params: {
        id: params.id!
      }
    },
    {
      skip: !params.id,
      selectFromResult: data => data
    }
  );
  const BUSINESS_TYPE = useMemo(() => {
    return checkTypeBusiness(business_types_property);
  }, [JSON.stringify(business_types_property)]);

  const PROPERTY_TYPE_ID = useMemo(() => {
    if (HCheckArray(type_property)) {
      return type_property[0].id;
    }
    return null;
  }, [type_property]);

  const PROPERTY_TYPE = useMemo(() => {
    if (HCheckArray(type_property)) {
      return CheckTypeProperty(type_property[0].id);
    }
    return CheckTypeProperty(null);
  }, [PROPERTY_TYPE_ID]);

  const PROPERTY_PROJECT_TYPE = useMemo(() => {
    if (HCheckArray(type_property)) {
      return CheckTypeProject(type_property[0].id);
    }
    return CheckTypeProperty(null);
  }, [PROPERTY_TYPE_ID]);

  const PROPERTY_STATUS = useMemo(
    () => checkStatusProperty(GET_PROPERTY_DETAIL.data?.status_id),
    [GET_PROPERTY_DETAIL.data?.status_id]
  );

  return {
    PROPERTY_TYPE,
    PROPERTY_TYPE_ID,
    PROPERTY_STATUS,
    BUSINESS_TYPE,
    PROPERTY_PROJECT_TYPE

  };
};

export default usePropertyFormHelp;

const checkStatusProperty = (id: number | undefined) => {
  return {
    PRECAPTURED: id == C_PROPERTIES_STATUS.PRECAPTURED.id,
    INNEGOTIATION: id == C_PROPERTIES_STATUS.INNEGOTIATION.id,
    INCONFLICT: id == C_PROPERTIES_STATUS.INCONFLICT.id,
    DROPPED: id == C_PROPERTIES_STATUS.DROPPED.id,
    PENDING: id == C_PROPERTIES_STATUS.PENDING.id,
    ACTIVE: id == C_PROPERTIES_STATUS.ACTIVE.id
  };
};

const CheckTypeProperty = (id: number | null) => {
  return {
    APARTMENT: id == C_REALESTATE_TYPES.APARTMENT.id,
    HOUSE: id == C_REALESTATE_TYPES.HOUSE.id,
    COMERCIAL_SITE: id == C_REALESTATE_TYPES.COMERCIAL_SITE.id,
    INDUSTRIAL_SITE: id == C_REALESTATE_TYPES.INDUSTRIAL_SITE.id,
    ESTATE: id == C_REALESTATE_TYPES.ESTATE.id,
    LAND: id == C_REALESTATE_TYPES.LAND.id,
    OFFICE: id == C_REALESTATE_TYPES.OFFICE.id,
    BUILDING: id == C_REALESTATE_TYPES.BUILDING.id,
    TURISTIC: id == C_REALESTATE_TYPES.TURISTIC.id,
    HOTEL: id == C_REALESTATE_TYPES.HOTEL.id,
    HOUSE_OR_LAND: id == C_REALESTATE_TYPES.HOUSE_OR_LAND.id,
    BUILDING_OR_LAND: id == C_REALESTATE_TYPES.BUILDING_OR_LAND.id,
    PROJECT: id == C_REALESTATE_TYPES.PROJECT.id,
    PENTHOUSE: id == C_REALESTATE_TYPES.PENTHOUSE.id,
    GAS_STATION: id == C_REALESTATE_TYPES.GAS_STATION.id,
    OFFICE_SITE: id == C_REALESTATE_TYPES.OFFICE_SITE.id
  };
};
const CheckTypeProject = (id: number | null) => {
  return {
    APARTMENT: id == C_REALESTATE_TYPES_PROJECT.APARTMENT.id,
    HOUSE: id == C_REALESTATE_TYPES.HOUSE.id,
    COMERCIAL_SITE: id == C_REALESTATE_TYPES.COMERCIAL_SITE.id,
    INDUSTRIAL_SITE: id == { ...C_REALESTATE_TYPES.INDUSTRIAL_SITE, id: 5 }.id,
    LAND: id == C_REALESTATE_TYPES.LAND.id
  };
};

const checkTypeBusiness = (type: I_GENERIC_ITEMS[]) => {
  if (HCheckArray(type)) {
    return {
      isSale: type[0].id == C_BUSINESS_TYPE.SALE.id,
      isRent: type[0].id == C_BUSINESS_TYPE.SELL.id,
      isSaleAndRent: type[0].id == C_BUSINESS_TYPE.SALE_AND_SELL.id
    };
  } else {
    return {
      isSale: false,
      isRent: false,
      isSaleAndRent: false
    };
  }
};

export interface usePropertyFormHelpReturn {
  PROPERTY_STATUS: {
    PRECAPTURED: boolean;
    INNEGOTIATION: boolean;
    INCONFLICT: boolean;
    DROPPED: boolean;
    PENDING: boolean;
    ACTIVE: boolean;
  };
  LOCATION: {
    isEdit: boolean;
    isCreate: boolean;
    isProject: boolean;
  };
  PROPERTY_TYPE: {
    APARTMENT: boolean;
    HOUSE: boolean;
    COMERCIAL_SITE: boolean;
    INDUSTRIAL_SITE: boolean;
    ESTATE: boolean;
    LAND: boolean;
    OFFICE: boolean;
    BUILDING: boolean;
    TURISTIC: boolean;
    HOTEL: boolean;
    HOUSE_OR_LAND: boolean;
    BUILDING_OR_LAND: boolean;
    PROJECT: boolean;
    PENTHOUSE: boolean;
    GAS_STATION: boolean;
    OFFICE_SITE: boolean;
  };
  PROPERTY_TYPE_ID: number | null;
  BUSINESS_TYPE: {
    isSale: boolean;
    isRent: boolean;
    isSaleAndRent: boolean;
  };
}

export const docId = {
  trust: 1,
  no_objection: 2,
  legal_status: 3,
  land_purchase: 4,
  environment: 5,
  building_license: 6,
  previous_mitur: 7,
  final_confotur: 8,
  aprocovici: 9,
  company_assembly_act: 10,
  enlarged_due_diligence: 11,
  credit_bureau: 12,
  company_rnc: 13,
  master_plan: 14,
  trust_transferred_title: 15,
  trust_transferred_title_builder: 16,
  commercial_register: 17,
  land_transfer_tax: 18,
  deposit_at_town_hall: 19,
  land_movement: 20,
  construction_company_resume: 21,
  temporal_legal_status: 22,
  acoprovi: 23
};
